import { API, axios, SendRequest, toastr} from '@/imports-files/pages/clients/activities/index';
import qs from 'qs';

export class DashboardService extends SendRequest {
  async getDashboardData()
  {
    const url = API.client.activities.DASHBOARD;
    let host_name = this.customHeaderJSON()
    try {
      const result = await axios.get( url,
          {
            headers: this.customHeaderJSON()
          },
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async updateOnboardingStep(params){
    const url = API.client.activities.UPDATE_ONBOARDING_STEP;
    try {
      const result = await axios.post( url,
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async dismiss(params){
    try {
      const result = await axios.post(API.client.activities.DISMISS_ONBOARDING,
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }


  async getActivityData()
  {
    try {
      const result = await axios.get(API.client.activities.SHOW_ACTIVITIES_DATA,
          {
            headers: this.customHeaderJSON()
          },
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async getScrollActivityData(params)
  {
    try {
      const result = await axios.get(API.client.activities.SHOW_ACTIVITIES_DATA,
          {
            headers: this.customHeaderJSON(),
            params: params
          },
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async getEventData(params)
  {
    try {
      const result = await axios.get(API.client.activities.SHOW_ACTIVITIES_DATA,
          {
            params: params,
            headers: this.customHeaderJSON(),
            paramsSerializer: function (params) {
                                                  return qs.stringify(params, {arrayFormat: 'brackets'})
                                                }
          },
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    }
    catch (error)
    {
      return error;
    }
  }


  async dismissNotification(params)
  {

    try
    {
        const result = await axios.post(API.client.activities.DISMISS_ALERT_COMM ,
        params,
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
        return result;
    }
    catch (error)
    {
      return error;
    }
  }

  async getOfferRejectedReason(params)
  {
    try {
      const result = await axios.get(API.client.activities.OFFER_REJECTED_REASONS.replace('$offer_id', params.offer_id),
          {
            params: params,
            headers: this.customHeaderJSON()
          },
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    }
    catch (error)
    {
      return error;
    }
  }

   async getJobRejectedReason(params)
  {
    try {
      const result = await axios.get(API.client.activities.OFFER_REJECTED_REASONS.replace('$offer_id', params.offer_id),
          {
            params: params,
            headers: this.customHeaderJSON()
          },
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    }
    catch (error)
    {
      return error;
    }
  }

}
